import React, {useEffect, useMemo, useState} from "react";
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Stack,
    TextField
} from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import CurrencyGenerator from "../services/CurrencyGenerator";
import {sortTypes} from "../services/Constants";
import NotificationsIcon from '@mui/icons-material/Notifications';
import {NotificationsOutlined} from "@mui/icons-material";
import {MobileTooltip} from "./Tooltip";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

export default function PanelListItem({
                                          searchParams,
                                          setFavoriteSearchIndex,
                                          favoriteSearchIndex,
                                          handleClose,
                                          setSearchParams,
                                          display,
                                          removeItem,
                                          item,
                                          index,
                                          itemIndex, open, subs, setUserSubscription, updateUser
                                      }) {
    const [loading, setLoading] = React.useState(false);
    const [loadingFavorite, setLoadingFavorite] = React.useState(false);
    const [loadingSub, setLoadingSubscription] = React.useState(false);
    const [loadingEditing, setLoadingEditing] = React.useState(false);
    const [isDialogOpen, setDialogOpen] = useState(false);
    const [isChanged, setIsChanged] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [keywords, setKeywords] = useState("");
    const isSubbed = useMemo(() => {
        return subs.includes(item);
    }, [subs])
    const isSubEnabled = useMemo(() => {
        if (index !== 0) return false;
        let searchParams = new URLSearchParams(item);
        let sort = searchParams.get('sort');
        return sort === "StartTimeNewest"
    }, [item])
    const opener = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    function openSearch() {
        setSearchParams(new URLSearchParams(item));
        handleClose();
    }

    function getSearchPrettified() {
        let searchParams = new URLSearchParams(item);
        let categoryName = searchParams.get('categoryName');
        let sort = searchParams.get('sort');
        let listingTypes = searchParams.get('listingTypes');
        let currency = searchParams.get('currency');
        let minPrice = searchParams.get('minPrice');
        let maxPrice = searchParams.get('maxPrice');
        let sellers = searchParams.get('blockedSellers');
        let countries = searchParams.get('blockedCountries');
        let alwaysShow = searchParams.get('alwaysOverlay');

        let output = categoryName;
        if (sort) {
            output += ", " + sortTypes[sort];
        }
        if (listingTypes) {
            let arr = listingTypes.split(',');
            if (arr[0] === 'Auction' || arr[0] === 'AuctionWithBIN') {
                output += ", Auction";
            } else {
                output += ", BIN";
            }
        }
        if (currency) {
            output += ", " + CurrencyGenerator.getCurrencyString(currency);
        }
        if (minPrice) {
            output += ", Min: " + CurrencyGenerator.getCurrencyString(currency, minPrice);
        }
        if (maxPrice) {
            output += ", Max: " + CurrencyGenerator.getCurrencyString(currency, maxPrice);
        }
        if (sellers === 'false') {
            output += ", All Sellers";
        }
        if (countries === 'false') {
            output += ", All Countries"
        }
        if (alwaysShow === 'true') {
            output += ", Always Overlay"
        }
        return output;
    }

    useEffect(() => {
        if (!open) setAnchorEl(null);
    }, [open])

    return (
        <>
            <ListItem sx={{padding: 0}} secondaryAction={
                <Stack direction="row" spacing={2} justifyContent={"space-between"}>

                            <MobileTooltip enterDelay={500} title={"More"}>
                                <IconButton
                                    aria-label="more"
                                    id="long-button"
                                    aria-controls={open ? 'long-menu' : undefined}
                                    aria-expanded={open ? 'true' : undefined}
                                    aria-haspopup="true"
                                    onClick={handleClick}
                                >
                                    <MoreVertIcon/>
                                </IconButton>
                            </MobileTooltip>
                            <Menu
                                anchorEl={anchorEl}
                                open={opener}
                                onClose={handleMenuClose}
                            >
                                {index === 0 &&
                                    <MenuItem onClick={() => {
                                        setDialogOpen(true);
                                        setKeywords(display);
                                        handleMenuClose();
                                        setIsChanged(false);
                                    }}>
                                        <ListItemIcon>
                                            <EditOutlinedIcon/>
                                        </ListItemIcon>
                                        Edit keywords</MenuItem>
                                }
                                {index === 0 &&
                                    <MenuItem onClick={itemIndex === favoriteSearchIndex ? null : (e) => {
                                        setFavoriteSearchIndex(itemIndex, setLoadingFavorite);
                                    }}>
                                        <ListItemIcon>
                                            {loadingFavorite ?
                                                <CircularProgress sx={{padding: "3px"}} size={24} thickness={5}/> :
                                                itemIndex === favoriteSearchIndex ?
                                                    <StarIcon sx={{color: '#EC407A'}}/> :
                                                    <StarBorderIcon/>}
                                        </ListItemIcon>
                                        Favorite</MenuItem>
                                }
                                {index === 0 && (isSubEnabled ?
                                    <MenuItem onClick={() => {
                                        setUserSubscription(item, setLoadingSubscription)
                                    }
                                    }>
                                        <ListItemIcon>
                                            {loadingSub ?
                                                <CircularProgress sx={{padding: "3px"}} size={24} thickness={5}/> :
                                                isSubbed ? <NotificationsIcon sx={{color: '#EC407A'}}/> :
                                                    <NotificationsOutlined/>}
                                        </ListItemIcon>
                                        Subscribe
                                    </MenuItem> :
                                    <MobileTooltip placement={'left'} title={`Subscribed searches must be sorted by "Newly Listed"`}>
                                        <span>
                                            <MenuItem disabled>
                                                <ListItemIcon>
                                                    <NotificationsOutlined/>
                                                </ListItemIcon>
                                                Subscribe
                                            </MenuItem>
                                        </span>
                                    </MobileTooltip>)
                                }
                                <MenuItem onClick={() => {
                                    removeItem(itemIndex, setLoading);
                                    handleMenuClose()
                                }}>
                                    <ListItemIcon>
                                        {loading ? <CircularProgress sx={{padding: "3px"}} size={24} thickness={5}/> :
                                            <DeleteIcon/>}
                                    </ListItemIcon>
                                    Delete</MenuItem>
                            </Menu>
                </Stack>
            }>
                <ListItemButton sx={{paddingRight: 0, minHeight: index === 0 ? "72px" : undefined}}
                                selected={index === 0 ? item === searchParams.toString() : null}
                                key={`${index}-${itemIndex}`} onClick={index === 0 ? openSearch : null}
                >
                    <ListItemText sx={{marginLeft: 1}}
                                  primary={display !== null ? display : item}
                                  secondary={display !== null ? getSearchPrettified() : null}
                    />
                </ListItemButton>
            </ListItem>
            <Divider sx={{marginLeft: 3}}/>
            {index === 0 &&
                <Dialog fullWidth open={isDialogOpen} onClose={() => setDialogOpen(false)}>
                    <DialogTitle>Edit keywords</DialogTitle>
                    <DialogContent>
                        <TextField
                            disabled={loadingEditing} value={keywords}
                            onInput={() => setIsChanged(true)}
                            onChange={(event) => {
                                setKeywords(event.target.value);
                            }} placeholder={"Keywords"} sx={{width: "100%"}} multiline/>
                    </DialogContent>
                    <DialogActions>
                        <Button disabled={!isChanged || loadingEditing} onClick={async () => {
                            await updateUser(
                                undefined, (bool) => {
                                    setLoadingEditing(bool);
                                    setDialogOpen(bool)
                                },
                                "Search keywords updated", undefined, undefined, undefined, undefined, item, keywords, itemIndex
                            )
                        }
                        }>
                            {
                                loadingEditing ?
                                    <CircularProgress sx={{padding: "3px"}} size={24} thickness={5}/> :
                                    "Save"
                            }
                        </Button>
                        <Button onClick={() => setDialogOpen(false)}>
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </>);

}